<div class="row text-center">
    <div *ngIf="InstallmentsList?.length==0;then NoInstallment else Installment"></div>

    <ng-template #NoInstallment>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate }}</p>
        </div>
    </ng-template>

    <ng-template #Installment>
        <div class="col-lg-12">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <mat-card-title class="mat-mdc-card-title text-white">
                        {{'Payments'|translate}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content text-center">
                    <div class="data" *ngIf="InstallmentsList">
                        <table class="table text-center">
                            <thead>
                                <tr>
                                    <th><span class="headTitle">{{'PaymentValue'|translate}}</span></th>
                                    <th><span class="headTitle">{{'PaymentStatus'|translate}}</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let installment of InstallmentsList">
                                    <td>
                                        <mat-form-field appearance="outline" class="w-100 m-b-10"
                                            *ngIf="!installment.isPayed">
                                            <input matInput value="{{installment.costPerMonth|arabicPrice }}" />
                                        </mat-form-field>

                                        <mat-label class="label" *ngIf="installment.isPayed">
                                            {{installment.costPerMonth|arabicPrice }}
                                        </mat-label>
                                    </td>
                                    <td>
                                        <button mat-flat-button color="primary"
                                            (click)="UpdateInstallment(installment.id)" *ngIf="!installment.isPayed">
                                            {{ installment.type}}
                                        </button>

                                        <button mat-flat-button class="btnPayed" *ngIf="installment.isPayed">
                                            {{ installment.type}}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="divBtn">
                        <button class="Cancelbtn" (click)="Cancel()">
                            {{ 'Cancel' | translate}}</button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-template>
</div>